<div
    fxLayout="column"
    fxFlex
    style="width: 100%; height: auto; background-color: #f7f7f7"
    *ngIf="!loading && !!this.data"
>
    <div
        [ngStyle.gt-xs]="{ height: '192px' }"
        *ngIf="!!data?.content?.subscribe"
    >
        <div
            fxLayout="column"
            fxLayoutAlign.gt-xs="center center"
            fxLayoutAlign.xs="flex-start"
            [ngClass]="{ pad40: 'true' }"
            [ngClass.xs]="{ pad_mobile: 'true' }"
        >
            <span
                [ngStyle.gt-xs]="{ marginBottom: '29px' }"
                style="margin-bottom: 27px"
                class="footer-page__description__large-text"
                ngClass.xs="footer-page__description__large-text__mobile"
                >{{ data?.content?.subscribe?.text }}</span
            >
            <mat-form-field
                [ngStyle.gt-xs]="{ width: '35%' }"
                appearance="outline"
                class="newsletter"
            >
                <input
                    type="email"
                    [formControl]="email"
                    placeholder="{{ data?.content?.subscribe?.placeholder }}"
                    matInput
                    (keyup)="checkValidEmail()"
                />
                <button
                    mat-flat-button
                    class="
                        secondary-call-to-action-button-subscribe
                        newsletter-button
                    "
                    matSuffix
                    (click)="
                        processLink(data?.content?.subscribe?.button?.link)
                    "
                    >{{ data?.content?.subscribe?.button?.text }}</button
                >
            </mat-form-field>
            <mat-error
                [style.color]="subscribeColor"
                style="padding-left: 1em; padding-top: 0.5em; font-size: 14px"
                [ngStyle.gt-xs]="{ width: '100%', marginLeft: '65%' }"
                >{{ subscribeMessage }}</mat-error
            >
        </div>
    </div>

    <div
        style="background-color: #ffffff; height: 192px"
        *ngIf="!!data?.content?.getInTouch"
    >
        <div
            fxLayout="column"
            fxLayoutAlign.gt-xs="center center"
            fxLayoutAlign.xs="flex-start"
            [ngClass]="{ pad40: 'true' }"
            [ngClass.xs]="{ pad_mobile: 'true' }"
        >
            <span class="footer-page__description__large-text">{{
                data?.content?.getInTouch?.text
            }}</span>
            <mat-form-field
                [ngStyle.gt-xs]="{ width: '53%' }"
                appearance="outline"
                class="newsletter"
            >
                <input
                    type="email"
                    [formControl]="email"
                    placeholder="{{ data?.content?.getInTouch?.placeholder }}"
                    matInput
                />
                <button
                    [disabled]="email.value!.length === 0"
                    mat-flat-button
                    class="secondary-call-to-action-button newsletter-button"
                    matSuffix
                    (click)="
                        processLink(data?.content?.getInTouch?.button?.link)
                    "
                    >{{ data?.content?.getInTouch?.button?.text }}</button
                >
            </mat-form-field>
            <mat-error
                [style.color]="subscribeColor"
                style="padding-left: 1em; font-size: 14px"
                >{{ subscribeMessage }}
            </mat-error>
        </div>
    </div>

    <hr
        *ngIf="data?.content?.getInTouch"
        [ngStyle.xs]="{ margin: '0px 19px' }"
    />

    <div fxLayout="column" style="color: #000">
        <!-- level-1 -->
        <!--        <hr />-->
        <div
            *ngIf="!!data?.featured?.images"
            style="overflow: hidden"
            fxLayout="column"
        >
            <p
                class="footer-page__heading"
                ngClass.xs="footer-page__heading__mobile"
                style="margin-top: 44px"
                fxLayoutAlign.gt-xs="center"
                fxLayout.xs="flex-start"
                [ngStyle.xs]="{ margin: '24px 17px 0 17px' }"
            >
                {{ data?.featured?.text }}
            </p>
            <div fxLayout="row wrap">
                <picture
                    *ngFor="let image of data?.featured?.images"
                    [ngStyle.xs]="{ margin: '0 17px' }"
                    class="image"
                >
                    <img src="{{ image }}" appImageCDN />
                </picture>
            </div>
            <div fxLayout.xs="flex-start" fxLayoutAlign.gt-xs="center">
                <button
                    *ngIf="data?.featured?.button"
                    mat-flat-button
                    class="mob-button"
                    ngClass.gt-xs="desk-button"
                    [ngStyle.xs]="{ margin: '28px 17px 28px 17px' }"
                    [ngStyle.gt-xs]="{ marginBottom: '53px' }"
                    style="background: {{
                        data?.featured?.button?.background || '#20A87E'
                    }};color:{{ data?.featured?.button?.title?.color }}"
                    (click)="processLink(data?.featured?.button?.link)"
                >
                    {{ data?.featured?.button?.title?.text }}
                </button>
            </div>
        </div>
        <hr *ngIf="data?.featured" [ngStyle.xs]="{ margin: '0px 19px' }" />
        <div
            fxShow.gt-xs="false"
            *ngIf="!!data?.rating?.image"
            fxLayout="column"
        >
            <p
                class="footer-page__heading"
                ngClass.xs="footer-page__heading__mobile"
                style="margin-top: 44px"
                fxLayoutAlign.gt-xs="center"
                fxLayout.xs="flex-start"
                [ngStyle.xs]="{ margin: '24px 17px 0 17px' }"
            >
                {{ data?.rating?.text }}
            </p>
            <div fxLayout="row wrap">
                <picture [ngStyle.xs]="{ margin: '0 17px' }" class="image">
                    <img src="{{ data?.rating?.image }}" appImageCDN />
                </picture>
            </div>
        </div>
        <hr fxShow.gt-xs="false" [ngStyle.xs]="{ margin: '0px 19px' }" />
        <div
            fxShow.xs="false"
            *ngIf="!!data?.rating?.image"
            style="overflow: hidden"
            fxLayout="column"
        >
            <p
                class="footer-page__heading"
                ngClass.xs="footer-page__heading__mobile"
                style="margin-top: 44px"
                fxLayoutAlign.gt-xs="center"
                fxLayout.xs="flex-start"
                [ngStyle.xs]="{ margin: '24px 17px 0 17px' }"
            >
                {{ data?.rating?.text }}
            </p>
            <div fxLayout="row wrap">
                <picture [ngStyle.xs]="{ margin: '0 17px' }" class="image">
                    <img src="{{ data?.rating?.image }}" appImageCDN />
                </picture>
            </div>
        </div>
        <hr fxShow="false" fxShow.gt-xs="true" />
        <div
            *ngIf="data?.content?.conformance?.length"
            fxLayout="row nowrap"
            fxLayoutGap.gt-xs="68px"
            fxLayoutGap="30px"
            fxLayoutAlign="center center"
            fxLayoutAlign.xs="center flex-start"
            style="padding: 31px 17px"
            [ngStyle.xs]="{ border: '1.5px solid #bfbfbf20' }"
        >
            <div *ngFor="let item of data?.content?.conformance">
                <div
                    [ngStyle]="{ fontSize: '14px' }"
                    [ngStyle.xs]="{ fontSize: '9px' }"
                    fxFlex
                    fxLayoutAlign="center center"
                    fxLayout.xs="column"
                    fxLayoutGap.xs="10px"
                    fxLayoutGap="20px"
                >
                    <img
                        [ngStyle]="{ width: '40px', height: '40px' }"
                        [ngStyle.xs]="{ width: '50px', height: '50px' }"
                        src="{{ item?.icon }}"
                        appImageCDN
                    /><span
                        class="conformance-text"
                        [ngStyle]="{ marginLeft: '20px' }"
                        [ngStyle.xs]="{ marginLeft: '10px', width: '100%' }"
                        >{{ item.text }}</span
                    >
                </div>
            </div>
        </div>
        <hr [ngStyle.xs]="{ margin: '0px 19px' }" />

        <!-- level-2 -->
        <div
            fxLayout="row"
            fxLayout.xs="column-reverse"
            fxLayoutAlign="space-between"
            *ngIf="data?.content?.staticPages.length > 0"
            style="min-height: 260px"
            [ngStyle]="{ fontSize: '14px' }"
            [ngStyle.xs]="{ fontSize: '13px' }"
        >
            <div
                fxLayout="row wrap"
                fxLayout.xs="column"
                fxFlex.gt-xs="0 0 68%"
                fxLayoutAlign.gt-xs="space-between"
                [ngStyle.gt-xs]="{ padding: '47px 0 25px 34px' }"
                [ngStyle.xs]="{ margin: '0px 17px' }"
            >
                <div
                    fxFlex.gt-xs="0 0 33%"
                    fxLayout="column"
                    *ngFor="
                        let staticPages of data?.content?.staticPages;
                        let i = index
                    "
                >
                    <mat-accordion fxShow.xs="true" fxShow.gt-xs="false">
                        <mat-expansion-panel
                            (opened)="setAccordionState(i)"
                            [expanded]="openAccordionIndex === i"
                            style="box-shadow: none; background-color: #f7f7f7"
                        >
                            <mat-expansion-panel-header
                                style="padding: 14px 8px 14px 0px"
                            >
                                <mat-panel-title>
                                    <span
                                        style="
                                            font-family: 'Roboto Condensed',
                                                sans-serif;
                                            font-size: 16px;
                                        "
                                        >{{ staticPages?.text }}</span
                                    >
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <div
                                *ngFor="let clickable of staticPages?.feed"
                                style="padding-bottom: 15px"
                            >
                                <div
                                    *ngIf="
                                        clickable.link.includes('https://');
                                        else noExternalMobile
                                    "
                                >
                                    <a
                                        href="{{ clickable.link }}"
                                        target="_blank"
                                        style="
                                            line-height: 13px;
                                            font-size: 13px;
                                            color: black;
                                        "
                                    >
                                        {{ clickable?.text }}
                                    </a>
                                </div>
                                <ng-template #noExternalMobile>
                                    <a
                                        (click)="
                                            clickable.link.includes('https://')
                                                ? externalLinksRedirect(
                                                      clickable.link
                                                  )
                                                : ''
                                        "
                                        [routerLink]="[
                                            clickable?.link | pageIdFromLink
                                        ]"
                                        [queryParams]="
                                            clickable.link | queryParamFromLink
                                        "
                                        style="
                                            line-height: 13px;
                                            font-size: 13px;
                                            color: black;
                                        "
                                        ><span>{{ clickable?.text }}</span></a
                                    >
                                </ng-template>
                            </div>
                        </mat-expansion-panel>
                    </mat-accordion>
                    <div fxShow.gt-xs="true" fxShow.xs="false">
                        <p
                            style="
                                margin-bottom: 24px;
                                font-family: 'Roboto Condensed', sans-serif;
                                font-size: 16px;
                            "
                            >{{ staticPages?.text }}</p
                        >
                        <div
                            *ngFor="let clickable of staticPages?.feed"
                            style="padding-bottom: 15px"
                        >
                            <div
                                *ngIf="
                                    clickable.link.includes('https://');
                                    else noExternal
                                "
                            >
                                <a
                                    href="{{ clickable.link }}"
                                    target="_blank"
                                    style="
                                        line-height: 13px;
                                        font-size: 13px;
                                        color: black;
                                    "
                                    ><span>{{ clickable?.text }}</span>
                                </a>
                            </div>
                            <ng-template #noExternal>
                                <a
                                    [routerLink]="[
                                        clickable?.link | pageIdFromLink
                                    ]"
                                    [queryParams]="
                                        clickable.link | queryParamFromLink
                                    "
                                    style="
                                        line-height: 13px;
                                        font-size: 13px;
                                        color: black;
                                    "
                                    ><span>{{ clickable?.text }}</span></a
                                >
                            </ng-template>
                        </div>
                    </div>
                    <hr fxShow="true" fxShow.gt-xs="false" />
                </div>
            </div>
            <hr [ngStyle.xs]="{ margin: '0px 19px' }" />
            <!--remove fxlayout-->
            <div fxFlex.gt-xs="0 0 32%" fxLayout="column">
                <div
                    fxFlex.gt-xs="0 0 50%"
                    [ngStyle.gt-xs]="{ padding: '47px 30px 47px 34px' }"
                    [ngClass.xs]="{ pad_mobile: 'true' }"
                    [ngStyle.xs]="{ padding: '27px 15px' }"
                    fxLayout="column"
                >
                    <span
                        [ngStyle.xs]="{ marginBottom: '16px' }"
                        class="footer-page__description__large-text"
                        ngClass.xs="footer-page__description__large-text__mobile-2"
                        >{{ data?.content?.social?.text }}</span
                    >
                    <div fxLayout="row" fxLayoutGap="9px">
                        <a
                            rel="noreferrer"
                            target="_blank"
                            href="{{ images?.link }}"
                            *ngFor="let images of data?.content?.social?.feed"
                        >
                            <img
                                style="
                                    width: 36px;
                                    height: 36px;
                                    cursor: pointer;
                                "
                                appImageCDN
                                src="{{ images?.icon }}"
                            />
                        </a>
                    </div>
                </div>
                <hr [ngStyle.xs]="{ margin: '0px 19px' }" />

                <div
                    fxFlex.gt-xs="0 0 50%"
                    [ngStyle.gt-xs]="{ padding: '47px 30px 47px 34px' }"
                    [ngClass.xs]="{ pad_mobile: 'true' }"
                    *ngIf="data?.content?.download"
                    [ngStyle.xs]="{ padding: '27px 15px' }"
                >
                    <span
                        class="footer-page__description__large-text"
                        ngClass.xs="footer-page__description__large-text__mobile-2"
                    >
                        {{ data?.content?.download?.text }}</span
                    >
                    <div
                        fxLayout="row"
                        fxLayoutGap.xs="23px"
                        fxLayoutGap.gt-xs="25px"
                        [ngStyle.gt-xs]="{ paddingTop: '12px' }"
                        [ngStyle.xs]="{ marginTop: '16px' }"
                    >
                        <img
                            style="width: 118px; height: 38px; cursor: pointer"
                            [ngStyle.gt-xs]="{ width: '90', height: '30' }"
                            *ngFor="
                                let iconable of data?.content?.download?.icons
                            "
                            (click)="externalLinksRedirect(iconable?.link)"
                            src="{{ iconable?.icon }}"
                            appImageCDN
                            alt=""
                        />
                    </div>
                </div>
                <hr
                    fxShow="true"
                    fxShow.gt-xs="false"
                    [ngStyle.xs]="{ margin: '0px 19px' }"
                />
                <!-- PaymentOptions -->
                <div
                    fxShow="true"
                    fxShow.gt-xs="false"
                    *ngIf="data?.content?.paymentOptions"
                    fxLayout="column"
                    fxLayout.xs="row wrap"
                    fxLayoutAlign.gt-xs="center center"
                    [ngStyle.gt-xs]="{ margin: '35px 0' }"
                    [ngStyle.xs]="{ marginLeft: '17px' }"
                >
                    <div
                        style="margin-bottom: 15px"
                        [ngStyle.xs]="{ margin: '26px 0 20px 0' }"
                    >
                        <span
                            class="payment-text"
                            [ngStyle.xs]="{ fontSize: '13px' }"
                            >{{ data?.content?.paymentOptions?.text }}</span
                        >
                    </div>
                    <div
                        fxLayout="row"
                        fxLayout.xs="row wrap"
                        fxLayoutGap.gt-xs="16px"
                        fxLayoutGap="15px"
                        [ngStyle.xs]="{ marginBottom: '18px' }"
                    >
                        <div
                            *ngFor="
                                let icon of data?.content?.paymentOptions?.icons
                            "
                            fxLayoutAlign="center center"
                        >
                            <picture
                                [ngStyle.gt-xs]="{
                                    width: '82px',
                                    margin: '0px'
                                }"
                                [ngStyle.xs]="{ width: '73px' }"
                                style="margin-bottom: 12px"
                            >
                                <img
                                    style="width: 100%"
                                    src="{{ icon }}"
                                    appImageCDN
                                />
                            </picture>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <hr fxShow="false" fxShow.gt-xs="true" />
        <!-- PaymentOptions -->
        <div
            fxShow="false"
            fxShow.gt-xs="true"
            *ngIf="data?.content?.paymentOptions"
            fxLayout="column"
            fxLayout.xs="row wrap"
            fxLayoutAlign.gt-xs="center center"
            [ngStyle.gt-xs]="{ margin: '35px 0' }"
            [ngStyle.xs]="{ marginLeft: '17px' }"
        >
            <div
                style="margin-bottom: 15px"
                [ngStyle.xs]="{ margin: '26px 0 20px 0' }"
            >
                <span
                    class="payment-text"
                    [ngClass.gt-xs]="{ fontSize: '16px' }"
                    >{{ data?.content?.paymentOptions?.text }}</span
                >
            </div>
            <div
                fxLayout="row"
                fxLayout.xs="row wrap"
                fxLayoutGap.gt-xs="16px"
                fxLayoutGap="15px"
                [ngStyle.xs]="{ marginBottom: '18px' }"
            >
                <div
                    *ngFor="let icon of data?.content?.paymentOptions?.icons"
                    fxLayoutAlign="center center"
                >
                    <picture
                        [ngStyle.gt-xs]="{ width: '82px', margin: '0px' }"
                        [ngStyle.xs]="{ width: '73px' }"
                        style="margin-bottom: 12px"
                    >
                        <img style="width: 100%" src="{{ icon }}" appImageCDN />
                    </picture>
                </div>
            </div>
        </div>

        <hr
            *ngIf="data?.content?.paymentOptions"
            fxShow="false"
            fxShow.gt-xs="true"
        />

        <!--breadcrumb-->
        <div
            *ngIf="breadcrumbs.length > 0"
            class="breadcrumb"
            fxLayout="nowrap"
            fxLayoutGap="7px"
            fxLayoutAlign.xs="center center"
            ngClass.xs="breadcrumn-mob"
        >
            <a
                class="breadcrumb-text"
                [routerLink]="[breadcrumb?.link | pageIdFromLink]"
                *ngFor="let breadcrumb of breadcrumbs"
                [queryParams]="breadcrumb.link | queryParamFromLink"
                fxLayout="row"
            >
                <p (click)="processLink(breadcrumb.link)"
                    >{{ breadcrumb.text }}
                </p>
                <span class="seperator"> > </span>
            </a>
        </div>

        <!--level-3-->
        <div
            *ngIf="data?.content?.mostSearched"
            fxLayout="column"
            class="padding-div"
            [ngStyle.xs]="{ padding: '0px 17px' }"
        >
            <mat-accordion fxShow.xs="true" fxShow.gt-xs="false">
                <mat-expansion-panel
                    (opened)="setAccordionState(-1)"
                    [expanded]="openAccordionIndex === -1"
                    style="box-shadow: none; background-color: #f7f7f7"
                >
                    <mat-expansion-panel-header
                        style="padding: 14px 8px 14px 0px"
                    >
                        <mat-panel-title>
                            <span
                                style="
                                    font-family: 'Roboto Condensed', sans-serif;
                                    font-size: 16px;
                                "
                            >
                                {{ data?.content?.mostSearched?.text }}
                            </span>
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div [ngStyle]="{ display: 'block' }">
                        <div
                            fxLayout.xs="column"
                            *ngFor="
                                let item of data?.content?.mostSearched?.feed;
                                let i = index
                            "
                            style="margin-bottom: 9px"
                            [ngStyle.xs]="{
                                paddingTop: '0',
                                height: 'fit-content'
                            }"
                            [ngStyle.gt-xs]="{
                                flex:
                                    i ===
                                    data?.content?.mostSearched?.feed.length - 1
                                        ? '1 0 33%'
                                        : '0 0 33%'
                            }"
                        >
                            <span
                                class="footer-page__description__text"
                                style="
                                    font-size: 13px;
                                    font-family: 'Roboto Condensed', sans-serif;
                                "
                            >
                                {{ item.text }}
                            </span>
                            <div
                                fxLayout="row wrap"
                                style="line-height: 20px"
                                fxLayoutAlign.xs="space-between"
                                [ngStyle.xs]="{ marginTop: '16px' }"
                                [ngStyle.gt-xs]="{
                                    marginTop: '15px',
                                    width: '100%',
                                    'max-height': '40vh',
                                    fontSize: '9px'
                                }"
                            >
                                <a
                                    fxFlex.gt-xs="0 0 180px"
                                    fxFlex.xs="0 0 45%"
                                    *ngFor="
                                        let clickable of item?.feed;
                                        let j = index;
                                        last as last
                                    "
                                    [routerLink]="[
                                        clickable?.link | pageIdFromLink
                                    ]"
                                    [queryParams]="
                                        clickable?.link | queryParamFromLink
                                    "
                                    fxLayoutAlign="space-between center"
                                    [ngStyle.xs]="{ marginRight: '0' }"
                                    style="
                                        color: black;
                                        margin-right: 20px;
                                        padding-bottom: 15px;
                                    "
                                >
                                    <span
                                        [ngStyle.xs]="{
                                            fontSize: '12px',
                                            ' white-space': 'nowrap',
                                            overflow: 'hidden',
                                            'text-overflow': 'ellipsis',
                                            width: '100%'
                                        }"
                                        class="
                                            footer-page__description__small-text
                                        "
                                    >
                                        {{ clickable?.text }}
                                    </span>
                                </a>
                            </div>
                        </div>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
            <div fxShow.gt-xs="true" fxShow.xs="false">
                <p
                    style="margin-bottom: 24px; font-size: 16px"
                    class="footer-page__description__large-text"
                >
                    {{ data?.content?.mostSearched?.text }}
                </p>
                <div [ngStyle]="{ display: 'block' }">
                    <div
                        fxLayout.xs="column"
                        *ngFor="
                            let item of data?.content?.mostSearched?.feed;
                            let i = index
                        "
                        style="margin-bottom: 9px"
                        [ngStyle.xs]="{
                            paddingTop: '0',
                            height: 'fit-content'
                        }"
                        [ngStyle.gt-xs]="{
                            flex:
                                i ===
                                data?.content?.mostSearched?.feed.length - 1
                                    ? '1 0 33%'
                                    : '0 0 33%'
                        }"
                    >
                        <span
                            class="footer-page__description__text"
                            style="
                                font-size: 13px;
                                font-family: 'Roboto Condensed', sans-serif;
                            "
                        >
                            {{ item.text }}
                        </span>
                        <div
                            fxLayout="row wrap"
                            style="line-height: 20px"
                            fxLayoutAlign.xs="space-between"
                            [ngStyle.xs]="{ marginTop: '16px' }"
                            [ngStyle.gt-xs]="{
                                marginTop: '15px',
                                width: '100%',
                                'max-height': '40vh',
                                fontSize: '9px'
                            }"
                        >
                            <a
                                fxFlex.gt-xs="0 0 180px"
                                fxFlex.xs="0 0 45%"
                                *ngFor="
                                    let clickable of item?.feed;
                                    let j = index;
                                    last as last
                                "
                                [routerLink]="[
                                    clickable?.link | pageIdFromLink
                                ]"
                                [queryParams]="
                                    clickable?.link | queryParamFromLink
                                "
                                fxLayoutAlign="space-between center"
                                [ngStyle.xs]="{ marginRight: '0' }"
                                style="
                                    color: black;
                                    margin-right: 20px;
                                    padding-bottom: 15px;
                                "
                            >
                                <span
                                    [ngStyle.xs]="{
                                        fontSize: '12px',
                                        ' white-space': 'nowrap',
                                        overflow: 'hidden',
                                        'text-overflow': 'ellipsis',
                                        width: '100%'
                                    }"
                                    class="footer-page__description__small-text"
                                >
                                    {{ clickable?.text }}
                                </span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <hr
            *ngIf="data?.content?.gifts"
            [ngStyle.xs]="{ margin: '0px 19px' }"
        />
        <div
            *ngIf="data?.content?.gifts"
            fxLayout="column"
            class="padding-div"
            [ngStyle.xs]="{ padding: '0px 17px' }"
        >
            <mat-accordion fxShow.xs="true" fxShow.gt-xs="false">
                <mat-expansion-panel
                    (opened)="setAccordionState(-2)"
                    [expanded]="openAccordionIndex === -2"
                    style="box-shadow: none; background-color: #f7f7f7"
                >
                    <mat-expansion-panel-header
                        style="padding: 14px 8px 14px 0px"
                    >
                        <mat-panel-title>
                            <span
                                style="
                                    font-family: 'Roboto Condensed', sans-serif;
                                    font-size: 16px;
                                "
                            >
                                {{ data?.content?.gifts?.text }}
                            </span>
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div [ngStyle]="{ display: 'block' }">
                        <div
                            fxLayout.xs="column"
                            *ngFor="
                                let item of data?.content?.gifts?.feed;
                                let i = index
                            "
                            style="margin-bottom: 9px"
                            [ngStyle.xs]="{
                                paddingTop: '0',
                                height: 'fit-content'
                            }"
                            [ngStyle.gt-xs]="{
                                flex:
                                    i === data?.content?.gifts?.feed.length - 1
                                        ? '1 0 33%'
                                        : '0 0 33%'
                            }"
                        >
                            <span
                                class="footer-page__description__text"
                                style="
                                    font-size: 13px;
                                    font-family: 'Roboto Condensed', sans-serif;
                                "
                            >
                                {{ item.text }}
                            </span>
                            <div
                                fxLayout="row wrap"
                                style="line-height: 20px"
                                fxLayoutAlign.xs="space-between"
                                [ngStyle.xs]="{ marginTop: '16px' }"
                                [ngStyle.gt-xs]="{
                                    marginTop: '15px',
                                    width: '100%',
                                    'max-height': '40vh',
                                    fontSize: '9px'
                                }"
                            >
                                <a
                                    fxFlex.gt-xs="0 0 180px"
                                    fxFlex.xs="0 0 45%"
                                    *ngFor="
                                        let clickable of item?.feed;
                                        let j = index;
                                        last as last
                                    "
                                    [routerLink]="[
                                        clickable?.link | pageIdFromLink
                                    ]"
                                    [queryParams]="
                                        clickable?.link | queryParamFromLink
                                    "
                                    fxLayoutAlign="space-between center"
                                    [ngStyle.xs]="{ marginRight: '0' }"
                                    style="
                                        color: black;
                                        margin-right: 20px;
                                        padding-bottom: 15px;
                                    "
                                >
                                    <span
                                        [ngStyle.xs]="{
                                            fontSize: '12px',
                                            ' white-space': 'nowrap',
                                            overflow: 'hidden',
                                            'text-overflow': 'ellipsis',
                                            width: '100%'
                                        }"
                                        class="
                                            footer-page__description__small-text
                                        "
                                    >
                                        {{ clickable?.text }}
                                    </span>
                                </a>
                            </div>
                        </div>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
            <div fxShow.gt-xs="true" fxShow.xs="false">
                <p
                    style="margin-bottom: 24px; font-size: 16px"
                    class="footer-page__description__large-text"
                >
                    {{ data?.content?.gifts?.text }}
                </p>
                <div [ngStyle]="{ display: 'block' }">
                    <div
                        fxLayout.xs="column"
                        *ngFor="
                            let item of data?.content?.gifts?.feed;
                            let i = index
                        "
                        style="margin-bottom: 9px"
                        [ngStyle.xs]="{
                            paddingTop: '0',
                            height: 'fit-content'
                        }"
                        [ngStyle.gt-xs]="{
                            flex:
                                i === data?.content?.gifts?.feed.length - 1
                                    ? '1 0 33%'
                                    : '0 0 33%'
                        }"
                    >
                        <span
                            class="footer-page__description__text"
                            style="
                                font-size: 13px;
                                font-family: 'Roboto Condensed', sans-serif;
                            "
                        >
                            {{ item.text }}
                        </span>
                        <div
                            fxLayout="row wrap"
                            style="line-height: 20px"
                            fxLayoutAlign.xs="space-between"
                            [ngStyle.xs]="{ marginTop: '16px' }"
                            [ngStyle.gt-xs]="{
                                marginTop: '15px',
                                width: '100%',
                                'max-height': '40vh',
                                fontSize: '9px'
                            }"
                        >
                            <a
                                fxFlex.gt-xs="0 0 180px"
                                fxFlex.xs="0 0 45%"
                                *ngFor="
                                    let clickable of item?.feed;
                                    let j = index;
                                    last as last
                                "
                                [routerLink]="[
                                    clickable?.link | pageIdFromLink
                                ]"
                                [queryParams]="
                                    clickable?.link | queryParamFromLink
                                "
                                fxLayoutAlign="space-between center"
                                [ngStyle.xs]="{ marginRight: '0' }"
                                style="
                                    color: black;
                                    margin-right: 20px;
                                    padding-bottom: 15px;
                                "
                            >
                                <span
                                    [ngStyle.xs]="{
                                        fontSize: '12px',
                                        ' white-space': 'nowrap',
                                        overflow: 'hidden',
                                        'text-overflow': 'ellipsis',
                                        width: '100%'
                                    }"
                                    class="footer-page__description__small-text"
                                >
                                    {{ clickable?.text }}
                                </span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Blogs section -->

        <hr
            *ngIf="data?.content?.blogs"
            [ngStyle.xs]="{ margin: '0px 19px' }"
        />
        <div
            *ngIf="data?.content?.blogs"
            fxLayout="column"
            [ngStyle.gt-xs]="{ padding: '0px 0 0 34px;' }"
            [ngStyle.xs]="{ padding: '0px 17px' }"
        >
            <mat-accordion fxShow.xs="true" fxShow.gt-xs="true">
                <mat-expansion-panel
                    (opened)="setAccordionState(-3)"
                    [expanded]="openAccordionIndex === -3"
                    style="box-shadow: none; background-color: #f7f7f7"
                >
                    <mat-expansion-panel-header
                        style="padding: 14px 8px 14px 0px"
                    >
                        <mat-panel-title>
                            <span
                                style="
                                    font-family: 'Roboto Condensed', sans-serif;
                                    font-size: 16px;
                                "
                            >
                                {{ data?.content?.blogs?.text }}
                            </span>
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div [ngStyle]="{ display: 'block' }">
                        <div
                            fxLayout.xs="column"
                            *ngFor="
                                let item of data?.content?.blogs?.feed;
                                let i = index
                            "
                            style="margin-bottom: 9px"
                            [ngStyle.xs]="{
                                paddingTop: '0',
                                height: 'fit-content'
                            }"
                            [ngStyle.gt-xs]="{
                                flex:
                                    i === data?.content?.blogs?.feed.length - 1
                                        ? '1 0 33%'
                                        : '0 0 33%'
                            }"
                        >
                            <span
                                class="footer-page__description__text"
                                style="
                                    font-size: 13px;
                                    font-family: 'Roboto Condensed', sans-serif;
                                "
                            >
                                {{ item.text }}
                            </span>
                            <div
                                fxLayout="row wrap"
                                style="line-height: 20px"
                                fxLayoutAlign.xs="space-between"
                                [ngStyle.xs]="{ marginTop: '16px' }"
                                [ngStyle.gt-xs]="{
                                    marginTop: '15px',
                                    width: '100%',
                                    'max-height': '40vh',
                                    fontSize: '9px'
                                }"
                            >
                                <a
                                    fxFlex.gt-xs="0 0 180px"
                                    fxFlex.xs="0 0 45%"
                                    *ngFor="
                                        let clickable of item?.feed;
                                        let j = index;
                                        last as last
                                    "
                                    href="{{ clickable?.link }}"
                                    target="_blank"
                                    fxLayoutAlign="space-between center"
                                    [ngStyle.xs]="{ marginRight: '0' }"
                                    style="
                                        color: black;
                                        margin-right: 20px;
                                        padding-bottom: 15px;
                                    "
                                >
                                    <span
                                        [ngStyle.xs]="{
                                            fontSize: '12px',
                                            ' white-space': 'nowrap',
                                            overflow: 'hidden',
                                            'text-overflow': 'ellipsis',
                                            width: '100%'
                                        }"
                                        class="
                                            footer-page__description__small-text
                                        "
                                    >
                                        {{ clickable?.text }}
                                    </span>
                                </a>
                            </div>
                        </div>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
        </div>

        <!--level-4-->
        <div
            class="padding-div"
            style="font-size: 13px"
            [ngStyle.gt-xs]="{
                textAlign: 'left',
                backgroundColor: data?.bottomBar?.color,
                color: data?.bottomBar?.title?.color,
                padding: '34px'
            }"
            [ngStyle.xs]="{
                textAlign: 'left',
                backgroundColor: data?.bottomBar?.color,
                color: data?.bottomBar?.title?.color,
                padding: '34px'
            }"
        >
            {{ data?.bottomBar?.title?.text }}
        </div>
    </div>
</div>
